import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, { theme: 'bubble', position: 'top-right', duration: 5000 });
